<template>
  <div class="w-100">
    <div class="mb-5">
      <div class="w-100 p-4 mb-4 border-b-form">
        <!-- PAYMENT CC XENDIT PENDING -->
        <div class="text-left" v-if="showXenditCreditCardForm">
          <XenditInputCC
            :tx_payment="data.payment_details"
            @done="reloadPage"
            @done-destroyed="reloadPage"
            @expired="reloadPage">
          </XenditInputCC>
        </div>

        <div v-else-if="showPaypalButton" class=""> 
          <img src="../../../assets/img/icon/payment-pending.png" class="mb-4 img-check">
          <p class="heading-4-1 text-green mb-2">Waiting for Payment</p>
          <div class="d-flex align-items-center w-100 justify-content-center mb-4">
            <p class="mb-0 body-2 mr-2">INVOICE:</p>
            <p class="mb-0 text-16 font-lato">{{ data.order_code }}</p>
          </div>
          <div class="rounded-6 border-2-green font-bold mb-3 text-16 py-2 px-4 bg-white d-table mx-auto cursor-pointer" @click="openPaypayLink()">
            <p class="text-green text-16 font-bold mb-0">Process Payment Now</p>
          </div>
        </div>
        
        <div class="text-center" v-else>
          <template v-if="data.status == 'COMPLETE' || data.status == 'NO_SHOW'">
            <img src="../../../assets/img/icon/green-checked-2.png" class="mb-4 img-check">
            <p class="heading-4-1 text-green mb-2">Your reservation is confirmed</p>
            <div class="d-flex align-items-center w-100 justify-content-center mb-4">
              <p class="mb-0 body-2 mr-2">INVOICE:</p>
              <p class="mb-0 text-16 font-lato">{{ data.order_code }}</p>
            </div>
            <div class="w-100">
              <button v-if="!isMasked" type="button" class="button-primary border bg-green px-4 mb-3 w-195px mx-2" @click="emit('getTXDetailPdf')">{{$t("hotel.success.print-detail-order")}}</button>
              <router-link :to="'/'+getMerchant.code+'/booking'" @click="emit('sendAnalytics','back_to_search')">
                <button type="button" class="button-primary bg-white text-black border px-4 w-195px mx-2 mb-3">{{$t("hotel.book-another-rooms")}}</button>
              </router-link>
              <button v-if="getMerchant.is_use_payment_result_custom_button" type="button" class="button-secondary border px-4 mb-3 w-195px mx-2" @click="$openLink(getMerchant.payment_result_custom_button_url,'_blank')">{{getMerchant.payment_result_custom_button_label}}</button>
            </div>
          </template>
          <template v-else-if="data.status == 'WAITING_CONFIRMATION'">
            <img src="../../../assets/img/icon/pending2.png" class="mb-4 img-check">
            <p class="heading-4-1 text-warning mb-2">Waiting Confirmation</p>
            <div class="d-flex align-items-center w-100 justify-content-center mb-4">
              <p class="mb-0 body-2 mr-2">INVOICE:</p>
              <p class="mb-0 text-16 font-lato">{{ data.order_code }}</p>
            </div>
            <div class="rounded-6 border-orange-2 font-bold mb-3 text-16 py-2 px-4 bg-white d-table mx-auto cursor-pointer" @click="emit('geTxDetail')">
              <p class="text-orange text-16 font-bold mb-0">Check Status</p>
            </div>
          </template>
          <template v-else-if="data.status == 'CANCELLED'">
            <img src="../../../assets/img/icon/cancel-red.png" class="mb-4 img-check">
            <p class="heading-4-1 text-danger mb-2">Cancelled</p>
            <p class="mb-4 body-2-4">Cancel Reason : {{ cancel_reason }}</p>
            <div class="d-flex align-items-center w-100 justify-content-center mb-4">
              <p class="mb-0 body-2 mr-2">INVOICE:</p>
              <p class="mb-0 text-16 font-lato">{{ data.order_code }}</p>
            </div>
            <router-link :to="'/'+getMerchant.code+'/booking'" @click="emit('sendAnalytics','back_to_search')">
              <button type="button" class="button-primary bg-white text-black border px-4 w-195px mx-2 mb-3">{{$t("hotel.book-another-rooms")}}</button>
            </router-link>
          </template>
        </div>
      </div>
      <div class="row">
        <!-- BOOKIN DETAIL -->
        <div class="col-12 col-lg-8 col-xl-7 mb-4">
          <div class="w-100 border-form radius-6 h-100 position-relative">
            <div class="p-3 border-b-form radius-t-6 position-relative">
              <p class="mb-0 body-1-4">Booking Detail</p>
              <div class="primary-overlay z-index-1025"></div>
            </div>
            <div class="pt-3 px-3 text-left">
              <!-- GENERAL -->
              <p class="mb-3 body-2-4 text-uppercase text-green">General Information</p>
              <div class="row mb-4">
                <div class="col-6">
                  <p class="mb-0 body-2-4">{{$t("hotel.success.transaction-date")}}</p>
                  <p class="mb-0 body-2">{{ isMasked ? "******" : $formatDate(data.created_at)}}</p>
                </div>
                <div class="col-6">
                  <p class="mb-0 body-2-4">{{$t("hotel.guests.guests")}}</p>
                  <p class="mb-0 body-2">{{ total_guest }}</p>
                </div>
              </div>
              <div class="row mb-4">
                <div class="col-6">
                  <p class="mb-0 body-2-4">{{$t("hotel.date.check-in")}}</p>
                  <p class="mb-0 body-2">{{ isMasked ? "******" : $formatDate(data.transaction_details[0].check_in_date)}}</p>
                </div>
                <div class="col-6">
                  <p class="mb-0 body-2-4">{{$t("hotel.date.check-out")}}</p>
                  <p class="mb-0 body-2">{{ isMasked ? "******" : $formatDate(data.transaction_details[0].check_out_date)}}</p>
                </div>
              </div>

              <!-- ROOM -->
              <div class="border-t-form-2-dashed">
                <div class="w-100 py-4 d-flex justify-content-between align-items-center" v-b-toggle.room-detail>
                  <p class="mb-0 body-2-4 text-uppercase text-green">Rooms</p>
                  <div class="lh-1">
                    <svg width="23" height="14" viewBox="0 0 23 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M11.4235 14C11.7521 14 12.0807 13.8685 12.3043 13.6187L22.4789 3.19435C22.7023 2.97088 22.8338 2.68167 22.8338 2.35304C22.8338 1.66947 22.321 1.14365 21.6375 1.14365C21.3089 1.14365 21.0066 1.2751 20.783 1.48543L10.7136 11.7784H12.1202L2.05069 1.48543C1.84037 1.2751 1.53802 1.14365 1.19625 1.14365C0.512674 1.14365 0 1.66947 0 2.35304C0 2.68167 0.131456 2.97088 0.354928 3.2075L10.5296 13.6187C10.7793 13.8685 11.0817 14 11.4235 14Z"
                        class="fill-primary" />
                    </svg>
                  </div>
                </div>
                <b-collapse visible id="room-detail" class="w-100 pb-4">
                  <div class="w-100" :class="{'mb-4' : index+1 < booked_room.length}" v-for="(room,index) in booked_room">
                    <div class="d-flex">
                      <div class="addt-serv-qty radius-6 border-form bg-grey-dark mr-3">
                        <p class="text-14 text-center font-lato mb-0">{{ room.qty }}x</p>
                      </div>
                      <div>
                        <p class="mb-0 body-2-4">{{ room.name }}</p>
                        <p class="mb-0 body-3">{{ room.room_type.name }}</p>
                        <p class="mb-0 text-orange text-12 font-lato">{{ roomPriceCounter(room.dates) }}</p>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </div>

              <!-- ADDITIONAL SERVICE -->
              <template v-if="data.additional_service_details.length > 0 || data.tx_merchant_pos.length > 0">
                <div class="border-t-form-2-dashed">
                  <div class="w-100 py-4 d-flex justify-content-between align-items-center" v-b-toggle.addt-service-detail>
                    <p class="mb-0 body-2-4 text-uppercase text-green">{{$t("hotel.additional-service")}}</p>
                    <div class="lh-1">
                      <svg width="23" height="14" viewBox="0 0 23 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M11.4235 14C11.7521 14 12.0807 13.8685 12.3043 13.6187L22.4789 3.19435C22.7023 2.97088 22.8338 2.68167 22.8338 2.35304C22.8338 1.66947 22.321 1.14365 21.6375 1.14365C21.3089 1.14365 21.0066 1.2751 20.783 1.48543L10.7136 11.7784H12.1202L2.05069 1.48543C1.84037 1.2751 1.53802 1.14365 1.19625 1.14365C0.512674 1.14365 0 1.66947 0 2.35304C0 2.68167 0.131456 2.97088 0.354928 3.2075L10.5296 13.6187C10.7793 13.8685 11.0817 14 11.4235 14Z"
                          class="fill-primary" />
                      </svg>
                    </div>
                  </div>
                  <b-collapse visible id="addt-service-detail" class="w-100 pb-4">
                    <ProductBookingResult :data="data" />
                  </b-collapse>
                </div>
              </template>

              <!-- SPECIAL REQUEST -->
              <template v-if="data.special_request_details.length > 0 || $isNotEmpty(data.custom_check_in_time) || $isNotEmpty(data.custom_check_out_time)">
                <div class="border-t-form-2-dashed">
                  <div class="w-100 py-4 d-flex justify-content-between align-items-center" v-b-toggle.special-request-detail>
                    <p class="mb-0 body-2-4 text-uppercase text-green">{{$t("hotel.special-request.title")}}</p>
                    <div class="lh-1">
                      <svg width="23" height="14" viewBox="0 0 23 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M11.4235 14C11.7521 14 12.0807 13.8685 12.3043 13.6187L22.4789 3.19435C22.7023 2.97088 22.8338 2.68167 22.8338 2.35304C22.8338 1.66947 22.321 1.14365 21.6375 1.14365C21.3089 1.14365 21.0066 1.2751 20.783 1.48543L10.7136 11.7784H12.1202L2.05069 1.48543C1.84037 1.2751 1.53802 1.14365 1.19625 1.14365C0.512674 1.14365 0 1.66947 0 2.35304C0 2.68167 0.131456 2.97088 0.354928 3.2075L10.5296 13.6187C10.7793 13.8685 11.0817 14 11.4235 14Z"
                          class="fill-primary" />
                      </svg>
                    </div>
                  </div>
                  <b-collapse visible id="special-request-detail" class="w-100 pb-4">
                    <div class="row">
                      <div class="col-6 mb-4" v-for="special_req in data.special_request_details">
                        <p class="mb-0 body-2-4">{{special_req.name}}</p>
                        <p class="mb-0 body-2">{{$isNotEmpty(special_req.notes) ? special_req.notes : '-'}}</p> 
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6 mb-4" v-if="$isNotEmpty(data.custom_check_in_time)">
                        <p class="mb-0 body-2-4">{{$t("hotel.special-request.request-check-in")}}</p>
                        <p class="mb-0 body-2">{{data.custom_check_in_time}}</p> 
                      </div>
                      <div class="col-6 mb-4" v-if="$isNotEmpty(data.custom_check_out_time)">
                        <p class="mb-0 body-2-4">{{$t("hotel.special-request.request-check-out")}}</p>
                        <p class="mb-0 body-2">{{data.custom_check_out_time}}</p> 
                      </div>
                      <div class="col-12 mb-4" v-if="$isNotEmpty(data.notes)">
                        <p class="mb-0 body-2-4">{{$t("hotel.special-request.other-request")}}</p>
                        <p class="mb-0 body-2">{{data.notes}}</p> 
                      </div>
                    </div>
                  </b-collapse>
                </div>
              </template>
            </div>
          </div>
        </div>

        <!-- CONTACT DETAIL -->
        <div class="col-12 col-lg-4 col-xl-5 mb-4">
          <div class="w-100 border-form radius-6 h-100 position-relative">
            <div class="p-3 border-b-form radius-t-6 position-relative">
              <p class="mb-0 body-1-4">Contact Detail</p>
              <div class="primary-overlay z-index-1025"></div>
            </div>
            <div class="py-4 px-4 text-left">
              <!-- BOOKED BY -->
              <p class="mb-3 body-2-4 text-uppercase text-green" v-if="is_booking_for_someone_else">Booked by</p>
              <div class="w-100 mb-4">
                <p class="mb-0 body-2-4">{{$t("hotel.visitor-detail.full-name")}}</p>
                <p class="mb-0 body-2">{{generateFullName(data.customer_details)}}</p>
              </div>
              <div class="w-100 mb-4">
                <p class="mb-0 body-2-4">{{$t("hotel.visitor-detail.email")}}</p>
                <p class="mb-0 body-2">{{data.customer_details.email}}</p>
              </div>
              <div class="w-100">
                <p class="mb-0 body-2-4">{{$t("hotel.visitor-detail.phone-number")}}</p>
                <p class="mb-0 body-2">{{data.customer_details.phone_number}}</p>
              </div>
              <div class="w-100 mt-4" v-if="$isNotEmpty(data.customer_details.day_of_birth)">
                <p class="mb-0 body-2-4">{{$t("hotel.visitor-detail.date-of-birth")}}</p>
                <p class="mb-0 body-2">{{$formatDate(data.customer_details.day_of_birth,'YYYY-MM-DD')}}</p>
              </div>
              <div class="w-100 mt-4" v-if="$isNotEmpty(data.customer_details.nationality)">
                <p class="mb-0 body-2-4">{{$t("hotel.visitor-detail.nationality")}}</p>
                <p class="mb-0 body-2">{{data.customer_details.nationality}}</p>
              </div>
              <div class="w-100 mt-4" v-if="$isNotEmpty(data.customer_details.country)">
                <p class="mb-0 body-2-4">{{$t("hotel.visitor-detail.country")}}</p>
                <p class="mb-0 body-2">{{data.customer_details.country}}</p>
              </div>

              <!-- BOOKED FOR -->
              <template v-if="is_booking_for_someone_else">
                <div class="border-t-form-2-dashed mt-4">
                  <div class="w-100 py-4 d-flex justify-content-between align-items-center" v-b-toggle.visitor-detail>
                    <p class="mb-0 body-2-4 text-uppercase text-green">Booked For</p>
                    <div class="lh-1">
                      <svg width="23" height="14" viewBox="0 0 23 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M11.4235 14C11.7521 14 12.0807 13.8685 12.3043 13.6187L22.4789 3.19435C22.7023 2.97088 22.8338 2.68167 22.8338 2.35304C22.8338 1.66947 22.321 1.14365 21.6375 1.14365C21.3089 1.14365 21.0066 1.2751 20.783 1.48543L10.7136 11.7784H12.1202L2.05069 1.48543C1.84037 1.2751 1.53802 1.14365 1.19625 1.14365C0.512674 1.14365 0 1.66947 0 2.35304C0 2.68167 0.131456 2.97088 0.354928 3.2075L10.5296 13.6187C10.7793 13.8685 11.0817 14 11.4235 14Z"
                          class="fill-primary" />
                      </svg>
                    </div>
                  </div>
                  <b-collapse visible id="visitor-detail" class="w-100 pb-4">
                    <div class="w-100 mb-4">
                      <p class="mb-0 body-2-4">{{$t("hotel.visitor-detail.full-name")}}</p>
                      <p class="mb-0 body-2">{{generateFullName(data.visitor_details)}}</p>
                    </div>
                    <div class="w-100 mb-4">
                      <p class="mb-0 body-2-4">{{$t("hotel.visitor-detail.email")}}</p>
                      <p class="mb-0 body-2">{{data.visitor_details.email}}</p>
                    </div>
                    <div class="w-100">
                      <p class="mb-0 body-2-4">{{$t("hotel.visitor-detail.phone-number")}}</p>
                      <p class="mb-0 body-2">{{data.visitor_details.phone_number}}</p>
                    </div>
                    <div class="w-100 mt-4" v-if="$isNotEmpty(data.visitor_details.day_of_birth)">
                      <p class="mb-0 body-2-4">{{$t("hotel.visitor-detail.date-of-birth")}}</p>
                      <p class="mb-0 body-2">{{$formatDate(data.visitor_details.day_of_birth,'YYYY-MM-DD')}}</p>
                    </div>
                    <div class="w-100 mt-4" v-if="$isNotEmpty(data.visitor_details.nationality)">
                      <p class="mb-0 body-2-4">{{$t("hotel.visitor-detail.nationality")}}</p>
                      <p class="mb-0 body-2">{{data.visitor_details.nationality}}</p>
                    </div>
                    <div class="w-100 mt-4" v-if="$isNotEmpty(data.visitor_details.country)">
                      <p class="mb-0 body-2-4">{{$t("hotel.visitor-detail.country")}}</p>
                      <p class="mb-0 body-2">{{data.visitor_details.country}}</p>
                    </div>
                  </b-collapse>
                </div>
              </template>
            </div>
          </div>
        </div>

        <!-- PAYMENT DETAIL -->
        <div class="col-lg-8 col-xl-7 mb-4">
          <div class="w-100 border-form radius-6 h-100 position-relative">
            <div class="p-3 border-b-form radius-t-6 position-relative">
              <p class="mb-0 body-1-4">Payment Detail</p>
              <div class="primary-overlay z-index-1025"></div>
            </div>
            <div class="p-3">
              <div class="row text-left justify-content-center">
                <div class="col-12">
                  <!-- TOP -->
                  <template v-if="data.payment_details != null && data.payments.total_deposit != 0">
                    <div class="row mb-3 no-gutters" v-if="data.payment_details.customer_bank_name != null">
                      <div class="col-6">
                        <div class="w-100 d-flex align-items-center justify-content-between">
                          <p class="mb-0 body-2">{{$t("hotel.payment-method.bank-name")}}</p>
                        </div>
                      </div>
                      <div class="col-6 text-right">
                        <p class="mb-0 pl-2 body-2">{{data.payment_details.customer_bank_name}}</p>
                      </div>
                    </div>
                    <div class="row mb-3 no-gutters">
                      <div class="col-6">
                        <div class="w-100 d-flex align-items-center justify-content-between">
                          <p class="mb-0 body-2">{{$t("general.payment-method")}}</p>
                        </div>
                      </div>
                      <div class="col-6 text-right">
                        <p class="pl-2 mb-0 body-2">{{data.payment_details.payment_method_name}}</p>
                      </div>
                    </div>
                    <div class="row mb-3 no-gutters">
                      <div class="col-6">
                        <div class="w-100 d-flex align-items-center justify-content-between">
                          <p class="mb-0 body-2">{{$t("hotel.payment-method.status")}}</p>
                        </div>
                      </div>
                      <div class="col-6 text-right">
                        <p class="pl-2 mb-0 body-2-4 text-green">{{data.status}}</p>
                      </div>
                    </div>
                  </template>
                  <div class="row mb-3 no-gutters">
                    <div class="col-6">
                      <div class="w-100 d-flex align-items-center justify-content-between">
                        <p class="mb-0 body-2">{{$t("hotel.success.room-charges")}}</p>
                      </div>
                    </div>
                    <div class="col-6 text-right">
                      <p class="mb-0 pl-2 font-lato text-14 text-subcolor">{{$formatCurrency(data.payments.total_payment - data.payments.total_additional, false, false, null, null, isMasked)}}</p>
                    </div>
                  </div>
                  <div class="row mb-3 no-gutters" v-if="data.payments.total_additional > 0">
                    <div class="col-6">
                      <div class="w-100 d-flex align-items-center justify-content-between">
                        <p class="mb-0 body-2">{{$t("hotel.additional-service")}}</p>
                      </div>
                    </div>
                    <div class="col-6 text-right">
                      <p class="mb-0 pl-2 font-lato text-14 text-subcolor">{{$formatCurrency(data.payments.total_additional, false, false, null, null, isMasked)}}</p>
                    </div>
                  </div>

                  <!-- MID -->
                  <div class="w-100 border-t-form-2-dashed mb-3"></div>
                  <div class="row mb-3 no-gutters">
                    <div class="col-6">
                      <div class="w-100 d-flex align-items-center justify-content-between">
                        <p class="mb-0 body-2-4">{{$t("hotel.total")}}</p>
                      </div>
                    </div>
                    <div class="col-6 text-right">
                      <p class="pl-2 mb-0 font-lato text-14 text-dark">{{$formatCurrency(data.payments.total_payment, false, false, null, null, isMasked)}}</p>
                    </div>
                  </div>
                  <div class="row mb-3 no-gutters">
                    <div class="col-6">
                      <div class="w-100 d-flex align-items-center justify-content-between">
                        <p class="mb-0" :class="data.payments.payment_surcharge > 0 ? 'body-2' : 'body-2-4'">{{$t("hotel.deposit-due-now")}}</p>
                      </div>
                    </div>
                    <div class="col-6 text-right">
                      <p class="mb-0 pl-2 font-lato text-14" :class="data.payments.payment_surcharge > 0 ? 'text-subcolor' : 'text-green'">{{$formatCurrency(roundUpIfXenditCC(data.payments.total_deposit), false, false, null, null, isMasked)}}</p>
                    </div>
                  </div>
                  <template v-if="data.payments.payment_surcharge > 0">
                    <div class="row mb-3 no-gutters">
                      <div class="col-6">
                        <div class="w-100 d-flex align-items-center justify-content-between">
                          <p class="mb-0 body-2">{{$t("hotel.payment-surcharge")}}</p>
                        </div>
                      </div>
                      <div class="col-6 text-right">
                        <p class="pl-2 mb-0 font-lato text-14 text-subcolor">{{$formatCurrency(roundUpIfXenditCC(data.payments.payment_surcharge), false, false, null, null, isMasked)}}</p>
                      </div>
                    </div>
                    <div class="row mb-3 no-gutters">
                      <div class="col-6">
                        <div class="w-100 d-flex align-items-center justify-content-between">
                          <p class="mb-0 body-2-4 text-green">Total {{$t("hotel.deposit-due-now")}}</p>
                        </div>
                      </div>
                      <div class="col-6 text-right">
                        <p class="pl-2 mb-0 font-lato text-14 text-green">{{$formatCurrency(roundUpIfXenditCC(data.payments.total_deposit)+roundUpIfXenditCC(data.payments.payment_surcharge), false, false, null, null, isMasked)}}</p>
                      </div>
                    </div>
                  </template>

                  <!-- BOTTOM -->
                  <template v-if="is_deposit_arrival">
                    <div class="w-100 border-t-form-2-dashed mb-3"></div>
                    <div class="row mb-3 no-gutters">
                      <div class="col-6">
                        <div class="w-100 d-flex align-items-center justify-content-between">
                          <p class="mb-0 sub-heading-1-2">{{$t("hotel.deposit-due-on-arrival")}}</p>
                        </div>
                      </div>
                      <div class="col-6 text-right">
                        <p class="pl-2 mb-0 font-lato text-18 text-orange">{{$formatCurrency(data.payments.total_payment - data.payments.total_deposit, false, false, null, null, isMasked)}}</p>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- TERMS & CONDITIONS -->
        <div class="col-12 col-lg-4 col-xl-5 mb-4">
          <div class="w-100 border-form radius-6 h-100 position-relative">
            <div class="p-3 border-b-form radius-t-6 position-relative">
              <p class="mb-0 body-1-4">{{ other_info.title }}</p>
              <div class="primary-overlay z-index-1025"></div>
            </div>
            <div class="py-4 px-4 text-left">
              <div class="d-block" :class="index+1 < other_info.list.length ? 'border-b-form-dashed-2 mb-4 pb-4' : ''" v-for="(other_info_item,index) in other_info.list">
                <p class="mb-3 body-2-4 text-green">{{ other_info_item.data.name }} <span v-if="data.transaction_details.length > 1" class="body-3">({{ other_info_item.room_rate }})</span></p>
                <p class="body-2-2 mb-0" v-html="other_info_item.data.description"></p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CancelBooking v-if="data.status == 'NO_SHOW'" :reason="data.cancellation_reason" :tx="data" @done="emit('geTxDetail')"></CancelBooking>
    </div>

    <b-modal 
      size="md"
      hide-footer
      hide-header
      v-model="showPopupLogin">
      <div class="p-4 position-relative">
        <div @click="togglePopupLogin()" class="p-3 position-absolute lh-1" style="top:-8px;right:-2px;">
          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.8008 2.21078L13.3908 0.800781L7.80078 6.39078L2.21078 0.800781L0.800781 2.21078L6.39078 7.80078L0.800781 13.3908L2.21078 14.8008L7.80078 9.21078L13.3908 14.8008L14.8008 13.3908L9.21078 7.80078L14.8008 2.21078Z" fill="#222222"/>
            <path d="M14.8008 2.21078L13.3908 0.800781L7.80078 6.39078L2.21078 0.800781L0.800781 2.21078L6.39078 7.80078L0.800781 13.3908L2.21078 14.8008L7.80078 9.21078L13.3908 14.8008L14.8008 13.3908L9.21078 7.80078L14.8008 2.21078Z" fill="black" fill-opacity="0.2"/>
          </svg>
        </div>
        <div class="w-100 pt-4 text-center">
          <svg class="mb-4" width="61" height="62" viewBox="0 0 61 62" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="2.5" y="2" width="56" height="58" rx="28" fill="var(--merchant-primary-color)" fill-opacity="0.2" />
            <g filter="url(#filter0_d_18388_37131)">
              <rect x="12.5" y="12" width="36" height="38" rx="18" fill="var(--merchant-primary-color)" fill-opacity="0.04"
                shape-rendering="crispEdges" />
              <path
                d="M30.5 33.1738C34.8384 33.1738 38.4997 33.8789 38.5 36.5986C38.5 39.3197 34.8146 40 30.5 40C26.1625 40 22.5002 39.295 22.5 36.5752C22.5 33.8542 26.1854 33.1738 30.5 33.1738ZM30.499 20C33.4381 20 35.7929 22.354 35.793 25.291C35.793 28.228 33.4381 30.583 30.499 30.583C27.5609 30.583 25.2051 28.228 25.2051 25.291C25.2051 22.354 27.561 20 30.499 20Z"
                fill="var(--merchant-primary-color)" />
            </g>
            <defs>
              <filter id="filter0_d_18388_37131" x="0.5" y="0" width="60" height="62" filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha" />
                <feOffset />
                <feGaussianBlur stdDeviation="6" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_18388_37131" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_18388_37131" result="shape" />
              </filter>
            </defs>
          </svg>
          <p class="heading-6-1 mb-0">Is this transaction yours?</p>
          <p class="body-2 mb-4">To view this data you must log in to your {{ data.customer_details.email }} account.</p>
          <div class="w-100 d-inline-flex align-items-center justify-content-center">
            <button @click="togglePopupLogin()" class="g-btn g-btn-md g-btn-white rounded border-form py-2-5 px-5 mr-1">
              Close
            </button>
            <button @click="goToLoginPage()" class="g-btn g-btn-md g-btn-primary rounded py-2-5 px-5 ml-1">
              Login
            </button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import ProductBookingResult from '@/components/hotel/be/additionalService/ProductBookingResult';
  import CancelBooking from '@/components/hotel/be/CancelBooking'
  import XenditInputCC from '@/components/hotel/be/XenditInputCC';
  import _ from 'lodash';
  
  export default {
    props: ['data'],
    components:{
      ProductBookingResult,
      CancelBooking,
      XenditInputCC
    },
    data(){
      return{
        showPopupLogin: false
      }
    },
    computed:{
      ...mapGetters(['getMerchant', 'isNotLogin']),
      total_guest(){
        let {adult,child,infant} = this.data.transaction_details[0]
        let return_data = `${adult} ${adult > 1 ? this.$t("hotel.adults.adults") : this.$t("hotel.adults.adult")}`
        if(child > 0){
          return_data += `, ${child} ${this.$t("hotel.children.children")}}`
        }
        if(infant > 0){
          return_data += `, ${infant} ${this.$t("hotel.infants.infants")}}`
        }
        return return_data
      },
      booked_room(){
        let rooms = []
        this.data.transaction_details.forEach(room=>{
          let same_room = rooms.findIndex(rm=>rm.room_rate_id == room.room_rate_id)
          if(same_room != -1){
            let total_dates = [...rooms[same_room].dates,...room.dates]
            rooms[same_room].qty++
            rooms[same_room].dates = total_dates
          }
          else rooms.push(room)
        })
        return rooms
      },
      is_booking_for_someone_else(){
        return !_.isEqual(this.data.customer_details,this.data.visitor_details)
      },
      is_deposit_arrival(){
      	return this.data.payments.total_payment - this.data.payments.total_deposit > 0 ? true : false
      },
      terms_and_conditions(){
        let list = []

        const findOrCreate = (data,rr_name) => {
          let entry = list.findIndex(tc=>tc.data.id == data.id);
          if (entry != -1) {
            list[entry].room_rate.push(rr_name)
          }else{
            let new_data = {
              data: data,
              room_rate: [rr_name]
            };
            list.push(new_data);
          }
        };
        
        this.data.transaction_details.forEach(room_rate => {
          let {name, term_and_condition_room_rate, term_and_condition_promotion} = room_rate
          if(this.$isNotEmpty(term_and_condition_room_rate)) findOrCreate(term_and_condition_room_rate, name)
          if(this.$isNotEmpty(term_and_condition_promotion)) findOrCreate(term_and_condition_promotion, name)
        });

        if(list.length > 0) list = list.map(x=>{
          x.room_rate = x.room_rate.join(', ')
          return x
        })
        
        return list
      },
      cancellation_policy(){
        let list = []
        
        
        if(this.terms_and_conditions.length == 0){

          const findOrCreate = (data,rr_name) => {
            let entry = list.findIndex(cp=>cp.data.id == data.id);
            if (entry != -1) {
              list[entry].room_rate.push(rr_name)
            }else{
              let new_data = {
                data: data,
                room_rate: [rr_name]
              };
              list.push(new_data);
            }
          };
          
          this.data.transaction_details.forEach(room_rate => {
            let {name, cancellation_policy} = room_rate
            if(this.$isNotEmpty(cancellation_policy)) findOrCreate(cancellation_policy, name)
          });

          if(list.length > 0) list = list.map(x=>{
            x.room_rate = x.room_rate.join(', ')
            return x
          })
        }

        return list
      },
      other_info(){
        let data = {
          title: 'Terms & Conditions',
          list: this.terms_and_conditions
        }

        if(this.terms_and_conditions.length == 0){
          data = {
            title: 'Cancellation Policy',
            list: this.cancellation_policy
          }
        }

        return data
      },
      cancel_reason(){
        return this.data.cancellation_reason.replace(`"END_USER"`, 'Guest (You)');
      },
      showXenditCreditCardForm(){
        const isDataEmpty = this.$isEmpty(this.data); 
        if(isDataEmpty) return false;

        const { status, payment_details: { bank_name, payment_channel } } = this.data; 
        const isStatusPendingPayment = status == 'WAITING_PAYMENT_CONFIRMATION';
        const isPaymentCreditCard = payment_channel == 'CREDIT_CARD'
        const isPaymentChannelXendit = bank_name == 'XENDIT' || bank_name== 'XENDIT_INTERNATIONAL'

        return isStatusPendingPayment && isPaymentCreditCard && isPaymentChannelXendit;
      },
      showPaypalButton(){
        const isDataEmpty = this.$isEmpty(this.data); 
        if(isDataEmpty) return false;

        const { status, payment_details: { bank_name, payment_method, payment_channel }} = this.data; 
        const isStatusPendingPayment = status == 'WAITING_PAYMENT_CONFIRMATION';
        const isPaymentPaypal = payment_method === 'PAYPAL' && bank_name === 'PAYPAL' &&  payment_channel === 'PAYPAL'

        return isStatusPendingPayment && isPaymentPaypal
      },
      isMasked(){
        if(this.$isEmpty(this.data)) return false;
        const { created_at = "*" } = this.data;
        return created_at === "*";
      }
    },
    mounted(){
      if(this.isMasked && this.isNotLogin){
        this.$nextTick(() => {
          this.togglePopupLogin()
        })
      }
    },
    methods:{
      roomPriceCounter(dates){
        let total = 0
        dates.forEach(date => {
          total += date.sub_total
        })
        return this.$formatCurrency(total, false, false, null, null, this.isMasked)
      },
      generateFullName(data){
        let full_name = this.$isNotEmpty(data.title) ? `${this.$capitalize(data.title)}. ${data.first_name}` : data.first_name  
        if(this.$isNotEmpty(data.last_name)) full_name += ` ${data.last_name}`
        return full_name
      },
      roundUpIfXenditCC(data){
      	let isNumber = Number(data)
      	if(Object.keys(this.data).length > 0 && this.data.payment_details.bank_name == 'XENDIT' && this.data.payment_details.payment_method == 'CREDIT_CARD'){
      		return Math.ceil(isNumber)
      	}else{
      		return isNumber
      	}
      },
      emit(func_name,data){
        this.$emit(func_name,data)
      },
      reloadPage(){
        window.location.reload()
      },
      openPaypayLink(){
        const isDataEmpty = this.$isEmpty(this.data); 
        const isLinkEmpty = this.$isEmpty(this.data.payment_details.url_redirect); 
        if(isDataEmpty || isLinkEmpty) return;
        
        return this.$openLink(this.data.payment_details.url_redirect);
      },
      togglePopupLogin(){
        this.showPopupLogin = !this.showPopupLogin
      },
      goToLoginPage(){
        if(this.$useCommunityAuth()){
          this.$loginWithCommunity()
        }else{
          this.$router.push({
            path: `/${this.merchant}/login`, query: { next_page: 'BePaymentResult', params: `tx_order_id.${this.$route.params.tx_order_id}` }
          })
        }
      }
    }
  }

</script>
<style>
  .img-check{
    height: 100px;    
  }
  @media screen and (max-width: 400px){
    .img-check{
      height: 60px;    
    }
  }
  .addt-serv-qty{
    width: 36px;
    height: 36px;
    display: grid;
    place-items: center;
    text-align: center;
    flex-shrink: 0;
  }
  .w-195px{
    width: 100%;
  }
  @media screen and (min-width: 769px){
    .w-195px{
      width: 195px;
    }
  }
  
</style>


// WEBPACK FOOTER //
// src/components/hotel/be/BookingResult.vue